var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cash-flow-report-tables" },
    [
      _vm.dataSource.length
        ? _c("a-table", {
            attrs: {
              size: "small",
              columns: _vm.getColumns,
              "data-source": _vm.tableRows,
              pagination: false,
              loading: _vm.loading,
              bordered: ""
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }